export default __webpack_public_path__ + "static/media/Landing.de14d657.png";